// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2oD5a","inputWrap":"Table_inputWrap__1U3wO","col":"Table_col__3SCG5","bmiTooltip":"Table_bmiTooltip__1sqFx"};